import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { useDispatch } from "react-redux";
import {
  continueFromPayment,
  getPaymentMethods,
  getReservation,
} from "../actions/paymentAction";
import { useEffect, useState } from "react";
import { toast } from "@/components/ui/use-toast";
import { useNavigate } from "react-router-dom";
import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
import PricingInfo from "./PricingInfo";
import { useMediaQuery } from "@/hooks/use-media-query";
import { isEmpty, isEmptyObj, isNumeric } from "../helpers/commonHelper";
import CustomPayment from "../pages/CustomPayment";
import Loading from "../common/Loading";
import { FiInbox } from "react-icons/fi";
import { DOMESTIC, INTERNATIONAL } from "../constants/flightTypes";
import { Paths } from "../constants/Paths";
import FonepayPayment from "./FonepayDynamicQRPayment";

export function Payment() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [paymentOptions, setPaymentOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const [reservationResp, setReservationResp] = useState(null);
  const [showManualPayment, setShowManualPayment] = useState(false);
  const [showDynamicQR, setShowDynamicQR] = useState(null);
  const [pricing, setPricing] = useState(null);
  const getPaymentOptions = (isPayLater, result = null) => {
    dispatch(
      getPaymentMethods(localStorage.currentFlightType == INTERNATIONAL, (methods) => {
        let paymentMethods = methods;
        if (isPayLater) {
          toast({
            duration: 20000,
            variant: "success",
            title: "Booked Success!",
            description: result?.Message,
          });
          paymentMethods = methods.filter(method => method.CheckoutType === 'PayLater');
        }
        setPaymentOptions(paymentMethods);
        setIsLoading(false);
      })
    );
  }
  const getCurrentIntlReservation = () => {
    dispatch(getReservation(localStorage.bookinfRef, false, (resp) => {
      if (resp) {
        debugger;
        const result = resp.Result;
        setReservationResp(result);

        const isPayLater = (result.IsManual && !result.IsGroup) || !result.CanIssueTicket;

        if (resp.SessionID != null)
          localStorage.setItem("transId", resp.SessionID)
        setPricing(resp.Result.Pricing);
        getPaymentOptions(isPayLater, result)
      }
      else {
        setIsLoading(false);
      }
    }))
  }
  useEffect(() => {
    if (isEmpty(localStorage.bookinfRef)) {
      navigate(Paths.MY_BOOKINGS);
    }

    if (!isNumeric(localStorage.bookinfRef)) {
      getCurrentIntlReservation();
    }
    else {
      getPaymentOptions(false);
    }
  }, []);
  const createDom = function (type, attr = {}) {
    let el = document.createElement(type);
    for (var key in attr) {
      if (attr.hasOwnProperty(key)) {
        el.setAttribute(key, attr[key]);
      }
    }
    return el;
  };
  const addFormInput = function (inp = [{ key: "", val: "" }], form) {
    inp.forEach(function (v) {
      form.appendChild(
        createDom("input", {
          type: "hidden",
          name: v.key,
          id: v.key,
          value: v.val,
        })
      );
    });
  };
  const handleContinue = () => {
    if (selectedMethod) {
      let payload = {
        bookingRef: localStorage.bookinfRef,
        gatewayID: selectedMethod,
        successFullURL: localStorage.currentFlightType == DOMESTIC ? location.origin + Paths.DOMESTIC_TICKET_PAGE : location.origin + Paths.INT_TICKET_PAGE,
        tranID: localStorage.transId,
        OrderEntity: localStorage.currentFlightType == DOMESTIC ? 2 : 1
      };
      var isManual = paymentOptions.filter(f => f.GatewayID == selectedMethod && f.CheckoutType == "Manual").length > 0;
      var isPayLater = paymentOptions.filter(f => f.GatewayID == selectedMethod && f.CheckoutType == "PayLater").length > 0;
      if (isPayLater) {
        navigate(Paths.MY_BOOKINGS);
      }
      else if (isManual) {
        setShowManualPayment(true);
      }
      else {
        dispatch(
          continueFromPayment(payload, (res) => {
            if (res.IsSuccess) {
              if (res.ActionName == "dynamicQr") {
                setShowDynamicQR(res);
              }
              else if (res.ActionName == 'renderElement') {
                const fm = createDom("form", {
                  method: "POST",
                  action: res.Result.requestURL + (res.Result.query ? `${res.Result.query}` : ""),
                });
                if (res.Result.inputs) {
                  addFormInput(res.Result.inputs, fm);
                }

                document.getElementsByTagName("body")[0].appendChild(fm);
                fm.submit();
              }
            }
          })
        )
      };
    } else {
      toast({
        variant: "destructive",
        title: "Select any one payment method",
        description: "You must select any payment method before proceeding !",
      });
    }
  };
  return (
    showDynamicQR ? <FonepayPayment rs={showDynamicQR} pricing={pricing} /> :
      (isNumeric(localStorage.bookinfRef) || pricing) && <div className=" bg-gray-100 dark:bg-background">
        <div className="container m-auto p-0 pb-20 lg:p-4 lg:pb-4">
          <div className="grid grid-cols-12 gap-4">
            {!showManualPayment ? <div className="col-span-12 lg:col-span-8 bg-background rounded-lg shadow p-4 lg:p-6">
              {/* Show TicketingNote if present */}
              {reservationResp?.TicketingNote && reservationResp.TicketingNote.trim() !== "" && (
                <div className="mb-4 p-3 rounded bg-yellow-100 text-yellow-900 border border-yellow-300">
                  <strong>Note:</strong> {reservationResp.TicketingNote}
                </div>
              )}
              <div className="mb-4">
                <h3 className="text-2xl font-semibold leading-none tracking-tight">
                  Pay to complete your booking
                </h3>
                <p className="text-sm text-muted-foreground">
                  Choose any payment methods
                </p>
              </div>
              {/* <div className="mb-4">
              <p className="text-sm text-muted-foreground">
                Your Booking Code - {reservationResp.BookingSummary.PNRNumber}
              </p>
            </div> */}
              <div className="mb-4">
                <RadioGroup
                  className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-3 lg:grid-cols-3 gap-4"
                  onValueChange={(name) => {
                    setSelectedMethod(name);
                  }}
                >
                  {/* <RadioGroupItem
                  value={"option.GatewayID"}
                  id={"option.GatewayID"}
                  className="peer sr-only"
                />
                <Label
                  htmlFor={"option.GatewayID"}
                  className="flex flex-col items-center justify-between rounded-md border-2 border-muted bg-popover p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary"
                >
                  <img src="https://connectips.com/knowmore/image/cips_logo.png" />
                </Label> */}

                  {paymentOptions && paymentOptions.length > 0
                    ? paymentOptions.map((option) => (
                      <div key={option.GatewayID}>
                        <RadioGroupItem
                          value={option.GatewayID}
                          id={option.GatewayID}
                          className="peer sr-only"
                        />
                        <Label
                          htmlFor={option.GatewayID}
                          className="flex flex-col items-center justify-between rounded-md border-2 border-muted bg-popover p-4 hover:bg-accent hover:text-accent-foreground peer-data-[state=checked]:border-primary [&:has([data-state=checked])]:border-primary h-full"
                        >
                          <img src={option.LogoUrl} />
                          {/* <img src={option.LogoUrl} /> */}
                          <span className="py-2">
                            {option.GatewayDisplayName}
                          </span>
                          {option.Description.length > 0 && <p className="text-sm text-muted-foreground ">{option.Description}</p>}
                        </Label>
                      </div>
                    ))
                    : isLoading ? <Loading label="Fetching payment options... Please wait!" /> : <div className='container-md text-center p-10'>
                      <FiInbox className='w-20 h-20 m-auto mb-4 text-gray-500' />
                      <h2 className='text-xl font-bold mb-3'>No Payment Option found..!</h2>
                      <p>Couldn't find any payment options. Contact us for more information.</p>
                    </div>}
                </RadioGroup>
              </div>
              {isDesktop && (
                <div className="flex gap-x-2">
                  <Button type="button" onClick={handleContinue}>
                    Continue
                  </Button>
                </div>
              )}
            </div> :
              <div className="col-span-12 lg:col-span-8 bg-background rounded-lg shadow p-4 lg:p-6">
                <CustomPayment handleBack={() => { setShowManualPayment(false) }} reservationResp={reservationResp} />
              </div>}
            {isDesktop && !isEmptyObj(reservationResp) && (
              <PricingInfo info={reservationResp} isFromPayment={true} />
            )}
          </div>

          {(!isDesktop && (!isNumeric(localStorage.bookinfRef) || pricing)) &&
            (<Drawer>
              <div className="flex justify-between py-2 px-4 bg-background shadow-lg fixed bottom-0 left-0 w-full border-t">
                <DrawerTrigger asChild>
                  <div className="cursor-pointer">
                    <h3>{pricing.Currency}. {pricing.GTotalFare}</h3>
                    <p className="text-primary text-xs">View Fare Breakdown</p>
                  </div>
                </DrawerTrigger>
                <Button onClick={handleContinue}>Continue</Button>
              </div>
              <DrawerContent>
                <div className="bg-background rounded-lg p-3 shadow">
                  <table className="w-full">
                    <thead>
                      <tr className="font-medium text-xl">
                        <td>Total Fare</td>
                        <td className="text-right">{pricing.Currency}. {pricing.GTotalFare}</td>
                      </tr>
                    </thead>
                    <tbody className="text-muted-foreground text-sm">
                      <tr>
                        <td className="py-2">Base Fare</td>
                        <td className="py-2 text-right">
                          {pricing.Currency}. {pricing.GTotalBaseFare}
                        </td>
                      </tr>
                      {pricing.GTotalTax > 0 && <tr>
                        <td className="py-2">TAX</td>
                        <td className="py-2 text-right">
                          {pricing.Currency}. {pricing.GTotalTax}
                        </td>
                      </tr>}
                      {pricing.Discount > 0 && <tr>
                        <td className="py-2">Discount</td>
                        <td className="py-2 text-right">
                          {pricing.Currency}. {pricing.Discount}
                        </td>
                      </tr>}
                      {pricing.Charges > 0 && <tr>
                        <td className="py-2">Service Charge</td>
                        <td className="py-2 text-right">
                          {pricing.Currency}. {pricing.Charges}
                        </td>
                      </tr>}
                    </tbody>
                  </table>
                </div>
              </DrawerContent>
            </Drawer>)
          }
        </div>
      </div>
  );
}
